import { globalHelperFunctions } from './src/functions/global-functions'
import * as globalDateFunctions from './src/functions/global-date-functions'
import { useCommandId } from './src/vue/composables/useCommandId'
import { useDateNowInterval } from './src/vue/composables/useDateNowInterval'
import { useDebounceFn } from './src/vue/composables/useDebounceFn'
import { useDisplay } from './src/vue/composables/useDisplay'
import { useLoading } from './src/vue/composables/useLoading'
import { useLocalStorage } from './src/vue/composables/useLocalStorage'
import { useResizeObserver } from './src/vue/composables/useResizeObserver'
import { useTheme } from './src/vue/composables/useTheme'
import { useWindowSize } from './src/vue/composables/useWindowSize'
import { useDetachedKeyboardNavigation } from './src/vue/composables/useDetachedKeyboardNavigation'
import { useDebouncedSearchInput } from './src/vue/composables/useDebouncedSearchInput'

export * from './src/vue/composables/useAppStateProvider'
export * from './src/vue/composables/useCommandId'
export * from './src/functions/promise-utils'
export {
  type ReturnToFormat,
  type ToFormatFormats,
  type ToFormatOptions
} from './src/functions/global-functions'

export { initializeGlobalAugmentation } from './src/functions/global-augmentation'

export { type ElementPosition } from './src/functions/global-functions'

export const globalUtils = {
  composables: {
    useTheme,
    useLocalStorage,
    useDisplay,
    useWindowSize,
    useResizeObserver,
    useDebounceFn,
    useCommandId,
    useDateNowInterval,
    useLoading,
    useDetachedKeyboardNavigation,
    useDebouncedSearchInput
  },
  functions: globalHelperFunctions,
  date: globalDateFunctions
}

export {
  useDebounceFn,
  useDisplay,
  useDateNowInterval,
  useLocalStorage,
  useLoading
}
